<template>
    <svg class="icon-eye" width="24" height="15" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="path" d="M23.556 9.03535C23.7786 8.71819 23.769 8.28523 23.5318 7.97813C19.9448 3.39181 16.0722 1.06592 12.0156 1.06592C5.13688 1.06592 0.359055 7.73145 0.160584 8.01337C-0.0620907 8.33054 -0.0524092 8.7635 0.184788 9.07059C3.76695 13.662 7.63956 15.9878 11.6961 15.9878C18.5748 15.9878 23.3527 9.32231 23.556 9.03535ZM11.6961 14.2611C8.31726 14.2611 5.02555 12.3278 1.89842 8.52185C3.12313 7.01657 7.0151 2.79271 12.0156 2.79271C15.3944 2.79271 18.6862 4.72592 21.8133 8.53192C20.5886 10.0372 16.6966 14.2611 11.6961 14.2611Z" />
        <path class="path" d="M11.8564 4.1416C9.53287 4.1416 7.64014 6.11005 7.64014 8.52655C7.64014 10.9431 9.53287 12.9115 11.8564 12.9115C14.18 12.9115 16.0727 10.9431 16.0727 8.52655C16.0727 6.11005 14.18 4.1416 11.8564 4.1416ZM11.8564 11.1847C10.4478 11.1847 9.30052 9.99156 9.30052 8.52655C9.30052 7.06155 10.4478 5.8684 11.8564 5.8684C13.2651 5.8684 14.4124 7.06155 14.4124 8.52655C14.4124 9.99156 13.2651 11.1847 11.8564 11.1847Z" />
        <rect v-if="showLine" class="path" x="4.26318" y="0.904297" width="1.27902" height="21.3484" transform="rotate(-45 4.26318 0.904297)" />
    </svg>
</template>

<script>
    export default {
        props: {
            showLine: {
                type: Boolean,
                required: false,
                default: false,
            },
        }
    }
</script>

<style lang="sass" scoped>
[v-cloak]
    display: none

</style>